import ms from 'ms';

export const projectDeletionTime = ms('14 days');
